var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotPermission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFF0FE"
    },
    d: "M3.657,32.5c-1.189,0-2.157-0.967-2.157-2.157V9.657C1.5,8.467,2.467,7.5,3.657,7.5h32.687   c1.189,0,2.157,0.967,2.157,2.157v20.687c0,1.189-0.967,2.157-2.157,2.157H3.657z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M36.343,8C37.257,8,38,8.743,38,9.657v20.687C38,31.257,37.257,32,36.343,32H3.657    C2.743,32,2,31.257,2,30.343V9.657C2,8.743,2.743,8,3.657,8H36.343 M36.343,7H3.657C2.189,7,1,8.189,1,9.657v20.687    C1,31.811,2.189,33,3.657,33h32.687C37.811,33,39,31.811,39,30.343V9.657C39,8.189,37.811,7,36.343,7L36.343,7z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#4788C7",
      strokeMiterlimit: 10
    },
    d: "M24.5,16.571c0,0,0-1.388,0-1.571c0-2.485-2.015-4.5-4.5-4.5  s-4.5,2.015-4.5,4.5c0,0.184,0,1.571,0,1.571"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98CCFD"
    },
    d: "M12.5,27.5v-8.833c0-1.195,0.972-2.167,2.167-2.167h10.667c1.195,0,2.167,0.972,2.167,2.167V27.5   H12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M25.333,17C26.252,17,27,17.748,27,18.667V27H13v-8.333C13,17.748,13.748,17,14.667,17H25.333    M25.333,16H14.667C13.194,16,12,17.194,12,18.667V28h16v-9.333C28,17.194,26.806,16,25.333,16L25.333,16z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4788C7"
    },
    cx: 20,
    cy: 21,
    r: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4788C7"
    },
    points: "20,20 20,20 22,25 18,25 "
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotPermission);
export default __webpack_public_path__ + "static/media/not_permission.12a53cba168b772290a05c24e55fcd39.svg";
export { ForwardRef as ReactComponent };